import BankEdit from '@/components/bank/edit/BankEdit.vue'
import BankPicker from '@/components/bank/picker/BankPicker.vue'
import { mapState } from 'vuex'

const defaultFilterValues = {
  name: '',
  isDeleted: [0]
};

export default {
  name: 'BankList',
  components: {
    BankEdit,
    BankPicker
  },
  data () {
    return {
      isMounted: false,
      loading: true,
      currentReq: null,
      tableItems: [],
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues),
      tableSorting: { item: 'name', direction: 'asc' },
      paging: { limit: 50, page: 1, total: 0, pages: 0 },
      mergebank: null
    };
  },
  computed: {
    ...mapState(['config']),
    tableHeaders () {
      const headers = [
        { key: 'name', label: this.$t('bank.name') },
        { key: 'swift', label: this.$t('bank.swift') },
        { key: 'accounts_count', label: this.$t('bank.accounts_count') }
      ];
      if (this.filterValues.isDeleted.includes(1)) {
        headers.push({ key: 'deleted_at', label: this.$t('general.item.deleted'), format: 'formatYesNo' });
      }
      if (this.canEdit) {
        const actions = [
          { label: this.$t('menu.bank.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' },
          { label: this.$t('menu.bank.delete'), emit: 'deleteItem', icon: 'delete', bicon: 'trash', ifconfig: { param: 'deleted_at', value: null } },
          { label: this.$t('menu.bank.restore'), emit: 'restoreItem', icon: 'restore', biocn: 'clock-history', ifconfig: { param: 'deleted_at', value: null, notCheck: true } },
          { label: this.$t('menu.bank.merge'), emit: 'mergeBank', icon: 'call_merge', bicon: 'box-arrow-in-up-left', ifconfig: { param: 'accounts_count', value: 0, notCheck: true } }
        ];
        headers.push({ key: 'actions', label: '', actions: actions });
      }
      return headers;
    },
    tableExpandConfig () {
      return { component: 'BankListExpand' };
    },
    tableFilterConfig () {
      const filters = { };
      filters.name = { type: 'text', label: this.$t('bank.title') };
      filters.isDeleted = { type: 'checkbox', label: this.$t('general.filters.deleted'), options: this.yesNoOptions };
      return filters;
    },
    canEdit () {
      return false;
    },
    requestPath () {
      let path = this.ApiRequest.addGetParamsToPath('bank/list?perPage=' + this.paging.limit + '&page=' + this.paging.page, this.filterValues, true);
      if (this.tableSorting.item) {
        path += '&order=' + this.tableSorting.item + ',' + this.tableSorting.direction;
      }
      return path;
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    tableActions () {
      const actions = { filters: true, reload: true };
      if (this.canEdit) {
        actions.add = { title: this.$t('menu.bank.new') };
      }
      return actions;
    }
  },
  methods: {
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.loading = true;
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      const self = this;
      this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.data) {
          self.tableItems = response.data;
          self.paging = response.paging;
          self.loading = false;
        }
      });
    },
    setDeleted (el, isDeleted) {
      this.loading = true;
      const self = this;
      this.ApiRequest.request('bank/deleted', this.ApiRequest.REQUEST_POST, { id: el.id, deleted: isDeleted }, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
          self.loading = false;
        } else {
          self.itemUpdated();
        }
      });
    },
    itemUpdated () {
      this.$emit('saved');
      this.getTableData();
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    deleteItem (el, approved) {
      if (el.accounts_count > 0) {
        this.$refs.infoMsgBox.show(null, this.$t('menu.bank.delete'), this.$t('api.bank.delete-has-acc'));
      } else if (approved) {
        this.setDeleted(el, 1);
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('bank.deleteTitle'), this.$t('bank.deleteMessage', { userName: el.name }))
      }
    },
    restoreItem (el) {
      this.setDeleted(el, 0);
    },
    mergeBanks () {
      this.loading = true;
      const self = this;
      const reqData = {
        from: this.mergebank.from.swift,
        to: this.mergebank.to.swift
      }
      this.ApiRequest.request('bank/merge', this.ApiRequest.REQUEST_POST, { bankmerge: reqData }, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
          self.loading = false;
        } else {
          const transData = {
            from_name: self.mergebank.from.name,
            from_swift: self.mergebank.from.swift,
            to_name: self.mergebank.to.name,
            to_swift: self.mergebank.to.swift
          };
          self.$refs.infoMsgBox.show(null, self.$t('bank.merge-success.title'), self.$t('bank.merge-success.message', transData));
          self.closeMergeAccounts();
          self.getTableData();
        }
      });
    },
    mergeBankForm (el) {
      this.mergebank = {
        from: this.BasicHelper.cloneObject(el),
        to: null
      }
      this.$refs.mergeAccounts.show();
    },
    closeMergeAccounts () {
      this.$refs.mergeAccounts.hide();
      this.mergebank = null;
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    },
    clearFilters () {
      this.filterValues = this.BasicHelper.cloneObject(defaultFilterValues);
      this.paging.page = 1;
      this.getTableData();
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.isMounted = true;
    this.getTableData();
  }
}
